export default {
  isProduction: process.env.VUE_APP_ENV === 'production',
  isDevelopment: process.env.VUE_APP_ENV === 'development',
};
